import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import {
    map
} from 'lodash';
import {
    Panel
} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import moment from 'moment';
import TableUtils from '../../../../../utils/TableUtils';
import TablePlain from '../../../../../components/table-plain/TablePlain';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import TableRelacionDependencia from './panel-datos-laborales/components/TableRelacionDependencia';
import TableEmpleadosAportes from '../../../../../components/table-empleados-aportes/TableEmpleadosAportes';
import TableSueldosCobrados from './panel-datos-laborales/components/TableSueldosCobrados';
import TableAutonomoMonotributista from './panel-datos-laborales/components/TableAutonomoMonotributista';
import TableAportes from './panel-datos-laborales/components/TableAportes';
import TableDomesticos from './panel-datos-laborales/components/TableDomesticos';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import TableJubilaciones from "./panel-datos-laborales/components/TableJubilaciones";

class PanelDatosLaborales extends React.Component {

	onRequestInfo = (infoKey, infoTitle) => {
		this.props.onRequestInfo(lstrings.datoslaborales_title, infoTitle);
	}

	render() {
		let titulo = <h2><i className="fa fa-briefcase"></i> {lstrings.datoslaborales_title}</h2>;

		let columnsAmountEmployees = [];
		let year = moment().get('y') - 6;
		for (let x = year; x <= (year + 5); x++) {
		columnsAmountEmployees.push(`${x}`);
		}
		columnsAmountEmployees.push('Actual');

		return (
			<ScrollableAnchor id={'panel-datoslaborales'}>
				<Panel collapsible defaultExpanded header={titulo}>

					<PermissionChecker
						infoKey='datoLaboral'
						infoTitle={lstrings.relaciondependencia_title}
						data={this.props.info.datoLaboral}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
						noCount
					>
						<TableRelacionDependencia
							cuil={this.props.cuil}
							data={this.props.info.datoLaboral}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels}
							rangoIngresos={this.props.rangoIngresos} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='jubilacion'
						infoTitle={lstrings.jubilacion_title}
						data={this.props.info.jubilacion}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableJubilaciones
							data={this.props.info.jubilacion}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels}
							rangoIngresos={this.props.rangoIngresos} />

					</PermissionChecker>

					<PermissionChecker
						infoKey='monotributista'
						infoTitle={lstrings.autonomo_title}
						data={this.props.info.monotributista}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableAutonomoMonotributista
							data={this.props.info.monotributista}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='aportesAM'
						infoTitle={lstrings.aportesAutonomoMonotributo_title}
						data={this.props.info.aportesAM}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableAportes
							data={this.props.info.aportesAM}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='actividad'
						infoTitle={lstrings.actividades_title}
						data={this.props.info.actividad}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{this.props.info.actividad &&
						<TablePlain
						columns={[lstrings.codigo, lstrings.actividad]}
						rows={map(this.props.info.actividad.datos, (item, ix) =>
							<tr key={ix}>
								<td>{item.ciiu}</td>
								<td>{item.descripcion}</td>
							</tr>)}
						/>}
					</PermissionChecker>

					<PermissionChecker
						infoKey='obraSocial'
						infoTitle={lstrings.obrasocial_title}
						data={this.props.info.obraSocial}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{this.props.info.obraSocial &&
						<TablePlain columns={[lstrings.codigo, lstrings.descripcion_title]}
						rows={map(this.props.info.obraSocial.datos, (item, ix) =>
							<tr key={ix}>
								<td>{TableUtils.stringFormat(item.codigo)}</td>
								<td>{TableUtils.stringFormat(item.descripcion)}</td>
							</tr>)}
						/>}
					</PermissionChecker>

					<PermissionChecker
						infoKey='empAportes'
						infoTitle={lstrings.emp_aportes_title}
						data={this.props.info.empAportes}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
						noCount noMoreBtn
					>
						<TableEmpleadosAportes
							data={this.props.info.empAportes}
							infoKey='empAportes'
							infoTitle={lstrings.emp_aportes_title}
							onRequestInfo={this.onRequestInfo}
							rangoIngresos={this.props.rangoIngresos}
							sinNomina
						/>
					</PermissionChecker>

					<PermissionChecker
						infoKey='sueldosCobrados'
						infoTitle={lstrings.sueldoscobrados_title}
						data={this.props.info.sueldos}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableSueldosCobrados
							data={this.props.info.sueldos}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='empDomesticos'
						infoTitle={lstrings.domesticosEmpleadosTitle}
						data={this.props.info.empDomesticos}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
						noCount
					>
						<TableDomesticos
							data={this.props.info.empDomesticos}
							tipoVisualizacion="empleado"
							onRequestInfo={this.onRequestInfo} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='domEmpleadores'
						infoTitle={lstrings.domesticosEmpleadorTitle}
						data={this.props.info.domEmpleadores}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
						noCount
					>
						<TableDomesticos
							data={this.props.info.domEmpleadores}
							tipoVisualizacion="empleador"
							onRequestInfo={this.onRequestInfo} />
					</PermissionChecker>

					<PermissionChecker
						infoKey='domAportes'
						infoTitle={lstrings.aportesServDomestico_title}
						data={this.props.info.domAportes}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						<TableAportes
							data={this.props.info.domAportes}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.props.hidePanels}
						/>
					</PermissionChecker>

					<PermissionChecker
						infoKey='seguridadSocial'
						infoTitle={lstrings.seguridadsocial_title}
						data={this.props.info.seguridadSocial}
						onRequestInfo={this.props.onRequestInfo}
						hidePanels={this.props.hidePanels}
					>
						{this.props.info.seguridadSocial &&
						<TablePlain
							columns={[lstrings.periodo, lstrings.seguridadsocialaportes, lstrings.seguridadsocialcontribuciones, lstrings.seguridadsocialretenciones, lstrings.obrasocialaportes, lstrings.obrasocialcontribuciones, lstrings.obrasocialretenciones]}
						rows={map(this.props.info.seguridadSocial.datos, (item, ix) =>
							<tr key={ix}>
								<td>{moment(item.periodo).year()}</td>
								<td>{item.segSocialAportes}</td>
								<td>{item.segSocialContribu}</td>
								<td>{item.segSocialRetencion}</td>
								<td>{item.obSocialAportes}</td>
								<td>{item.obSocialContribu}</td>
								<td>{item.obSocialRetencion}</td>
							</tr>)}
						/>}
					</PermissionChecker>

				</Panel>
			</ScrollableAnchor>
		);
	}
}

PanelDatosLaborales.propTypes = {
	cuil: PropTypes.string,
	info: PropTypes.object,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any,
	rangoIngresos: PropTypes.object
}

export default PanelDatosLaborales;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelDatosLaborales.js